const KoTicketTable_COLUMNS = [
  {
    name: "ticketId",
    id: "ticketId",
    label: "Ticket Id",
    width:130,
    widget: "ticketLink",
    fixed: true
  },

  {
    name: "summary",
    id: "summary",
    label: "Summary",
    width:230,
    widget: "text"
  },
  {
    name: "status",
    id: "status",
    label: "Status",
    widget: "taskstatus",
    isLog:true,
    width:130
  },
  {
    name: "priority",
    id: "priority",
    label: "Priority",
    widget: "priority",
    width:110
  },
  {
    name: "endDate",
    id: "endDate",
    label: "Due Date",
    format: "DD-MMM-YYYY",
    widget: "date",
    width:150
  },
  {
    name: "overdueDays",
    id: "overdueDays",
    label: "Overdue in Days",
    widget: "overDueStatus",
    width:150
  },
  {
    name: "assignee",
    id: "assignee",
    label: "Assignee",
    widget: "assignees"
  },
  // {
  //   name: "attachments",
  //   id: "attachments",
  //   label: "Attachments",
  //   widget: "attachments"
  // },
  {
    name: "reporter",
    id: "reporter",
    label: "Reporter",
    widget: "assignees"
  },
  {
    name: "module",
    id: "module",
    label: "Module"
  },
  {
    name: "component",
    id: "component",
    label: "Component"
  }

];


const TESTCASE_COLUMNS = [
  {
    name: "caseId",
    id: "caseId",
    label: "Testcase Id",
    width:130,
    widget: "ticketLink",
    fixed: true
  },
  {
    name: "type",
    id: "type",
    label: "Case Type",
    widget: "caseType"
  },
  {
    name: "prerequisite",
    id: "prerequisite",
    label: "Prerequisite",
    widget: "richText"
  },
  {
    name: "testData",
    id: "testData",
    label: "Test Data",
    widget: "richText"
  },
  {
    name: "expectedResult",
    id: "expectedResult",
    label: "Expected Result",
    widget: "richText"
  },
  {
    name: "actualResult",
    id: "actualResult",
    label: "Actual Result",
    widget: "richText"
  },
  {
    name: "stepsReproduce",
    id: "stepsReproduce",
    label: "Steps Reproduce",
    widget: "richText"
  },
  {
    name: "description",
    id: "description",
    label: "Description",
    widget: "richText"
  },
  {
    name: "createdBy",
    id: "createdBy",
    label: "created By",
    widget: "assignees"
  },
  {
    name: "createdAt",
    id: "createdAt",
    label: "Created At",
    widget: "date"
  }];

export const WORKLOG_COLUMNS = [
  {
    name: "createdBy",
    id: "createdBy",
    label: "Assignee",
    widget: "assignees",
    width:100
  },
  {
    name: "description",
    id: "description",
    label: "Description",
    width:200,
    widget: "richText"
  },
  {
    name: "timeSpent",
    id: "timeSpent",
    label: "TimeSpent",
    widget: "log",
    width:100
  },
  {
    name: "timeRemaining",
    id: "timeRemaining",
    label: "Time Remaining",
    widget: "log",
    width:150
  },
  {
    name: "date",
    id: "date",
    label: "Date",
    format: "DD-MMM-YYYY",
    widget: "date",
    width:150
  }];

const COLUMNS_ATTACHMENTS = [
  {
    id: "name",
    label: "File Name",
    width: 300,
    widget: "file"
  }, {
    id: "createrProfile",
    label: "Owner",
    widget: "staticmember",
    width: 200
  },  {
    id: "lastModifiedDate",
    label: "Created At",
    widget: "date",
    width: 200
  }
];
  

export  {KoTicketTable_COLUMNS, TESTCASE_COLUMNS, COLUMNS_ATTACHMENTS};